import { render } from "./MPopupManager.vue?vue&type=template&id=6c8306cc&scoped=true"
import script from "./MPopupManager.vue?vue&type=script&lang=js"
export * from "./MPopupManager.vue?vue&type=script&lang=js"

import "./MPopupManager.vue?vue&type=style&index=0&id=6c8306cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8306cc"]])

export default __exports__